// extracted by mini-css-extract-plugin
export default {"avatarContainer":"ViewInfo_avatarContainer__4yUJc","icon":"ViewInfo_icon__w2dID","title":"ViewInfo_title__Qg42r"};